import React from "react";
import BreadcrumbSection from "./BreadcrumbSection";
import AboutWelcomeSection from "./AboutWelcomeSection";
import VisionMission from "./VisionMission";
import WhyChoose from "./AboutWychooseSection";
import TeamSection from "./TeamSection";
import AboutVideoSection from "./AboutVideoSection";
import BredcrumpImage from "../assets/images/bredcrump.jpg";

const About = () => {
  return (

    <>

     <BreadcrumbSection
        title="Bridging Science and Results in Skin & Hair Health"
        subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" },
         
        ]}
        backgroundImage={BredcrumpImage}
      />
      <AboutWelcomeSection />
      <WhyChoose />
      <VisionMission />
      <TeamSection />
      <AboutVideoSection />
      {/* <h1>Welcome to the About Us Page of Biopharma Products</h1>; */}
    </>
  );
};

export default About;
